import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CK_CONFIGS } from "configs";
import React, { useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import Select from "react-select";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { isEmpty } from 'lodash';

// import CKEditor from '@ckeditor/ckeditor5-react';
import { userFetch, updateWorkspaceAccess, redirectToWorkspaceAccessList } from "actions";
const AccessPage = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const workspaceAccessState = useSelector(state => state.workspaceAccessState);
  const session = useSelector(state => state.session);
  const themeState = useSelector(state => state.themeState);

  const [workspaceAccessRecord, setWorkspaceAccessRecord] = useState({});
  const [workspace_id, setWorkspaceId] = useState('');
  const [selectedUsers, setSelectedUsers] = useState([]);
  const userList = useSelector(state => state.workspaceState.getUser);
  const [formState, setFormState] = useState({
    isValid: false,
    values: {
      'object_viewed_id': session.current_page_permissions.object_id,
    },
    touched: {
      'object_viewed_id': true,
    },
    errors: {}
  });

  useEffect(() => {
    if (workspaceAccessState.workspaceAccessRecord) {
      const record = workspaceAccessState.workspaceAccessRecord;
      setWorkspaceAccessRecord(record);
      setWorkspaceId(record?.id || '');
      const existingUsers = (workspaceAccessState.workspaceAccessRecord.users || []).map((user) => ({
        label: user.name,
        value: user.id,
      }));

      setSelectedUsers(existingUsers);

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspaceAccessState.workspaceAccessRecord]);

  useEffect(() => {
    if (workspaceAccessState.redirect_to_list) {
      navigate('/workspaceaccess');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspaceAccessState.redirect_to_list]);

  useEffect(() => {
    if (!workspaceAccessState.showViewPage && !workspaceAccessState.showUpdateForm) {
      navigate('/workspaceaccess');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspaceAccessState.showViewPage, workspaceAccessState.showUpdateForm]);

  useEffect(() => {
    dispatch(userFetch());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const customStyles = () => ({
    control: (provided, state) => ({
      ...provided,
      borderRadius: "60px",
      border: themeState.themeMode === "dark" ? "none" : "1px solid #ccc",
      borderColor: state.isFocused ? "#888" : "#ddd",
      backgroundColor: themeState.themeMode === "dark" ? "#333" : "#fff",
      boxShadow: state.isFocused ? provided.boxShadow : "none",
      "&:hover": {
        backgroundColor: themeState.themeMode === "dark" ? "#333" : "#f0f0f0",
        borderColor: state.isFocused ? "#888" : "#ccc",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: themeState.themeMode === "dark" ? "#B0B0B0" : "#000000", // Text color of selected option
    }),
    placeholder: (provided) => ({
      ...provided,
      color: themeState.themeMode === "dark" ? "#B0B0B0" : "#666666", // Placeholder text color
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: themeState.themeMode === "dark" ? "#333" : "#fff",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused
        ? themeState.themeMode === "dark"
          ? "#555"
          : "#f0f0f0"
        : themeState.themeMode === "dark"
          ? "#333"
          : "#fff",
      color: themeState.themeMode === "dark" ? "#ffffff" : "#000000", // Option text color
      "&:hover": {
        backgroundColor: themeState.themeMode === "dark" ? "#444" : "#e0e0e0",
      },
    }),
  });


  useEffect(() => {
    setFormState((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        user_id: (workspaceAccessRecord.users || []).map((user) => user.id),
        workspace_id: workspace_id,
        description: workspaceAccessRecord?.workspace_accesses?.[0]?.description || '',
      },
    }));
  }, [workspaceAccessRecord, workspace_id]);

  const setDescription = description => {
    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        'description': description
      },
      touched: {
        ...formState.touched,
        'description': true
      }
    }));
    // dispatch(hideWorkspaceValidationError('description'))
  }


  const userNames = (userList || []).map((user) => ({
    label: user.name,
    value: user.id,
  }));



  const handleUserChange = (selectedOptions) => {
    setSelectedUsers(selectedOptions); // Update the state with the newly selected users

    // Update formState with the selected user IDs
    const selectedUserIds = selectedOptions ? selectedOptions.map(option => option.value) : [];

    setFormState((prevFormState) => ({
      ...prevFormState,
      values: {
        ...prevFormState.values,
        user_id: selectedUserIds,
      },
    }));
  };

  const handleClose = () => {
    dispatch(redirectToWorkspaceAccessList());
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    dispatch(updateWorkspaceAccess(formState.values));
  };

  const hasError = field =>
    formState.touched[field] && formState.errors[field] ? true : false;

  return (
    <>
      <div>
        <div class="access-page">
          <div class="access-text-holder text-center">
            <h3 className="font-20 font-weight-s-bold page-heading">Workspace Access</h3>
            <p className="font-11 font-weight-normal page-heading">AI Management</p>
          </div>
        </div>
        <div className="access-content">
          <Row>
            <Col>
              <Form.Label className="font-13 font-weight-normal page-heading">
                Workspace
              </Form.Label>
              <Select
                isDisabled
                placeholder={
                  !isEmpty(workspaceAccessRecord) ?
                    workspaceAccessRecord.name : ''
                }
                isSearchable={true}
                className="font-14 font-weight-normal worspace-access"
                styles={customStyles()}
              />
            </Col>
            <Col>
              <Form.Label className="font-13 font-weight-normal page-heading">
                Select Users
              </Form.Label>
              <Select
                isMulti
                placeholder="Select"
                isSearchable={true}
                className="font-14 font-weight-normal worspace-access"
                styles={customStyles()}
                options={!isEmpty(userNames) ? userNames : ''}
                onChange={handleUserChange}
                value={selectedUsers}
              />
            </Col>
          </Row>
          <Row className="my-4">
            <Col md={12} className="mx-auto mb-3=4">
              <CKEditor
                editor={ClassicEditor}
                config={CK_CONFIGS(localStorage.getItem("token"))}
                data={formState.values.description || ''}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setDescription(data);
                }}
              />
              {hasError('description') && (
                <Form.Text className="text-danger">
                  {formState.errors.description[0]}
                </Form.Text>
              )}

            </Col>
          </Row>
          <div>
            <Button variant="none" className="border-0 gradient-btn font-13 font-weight-medium" onClick={handleSubmit}>Update Access</Button>
            <Button variant="none" className="font-13 font-weight-medium gradient-border px-3 page-heading" onClick={handleClose}>Cancel</Button>
          </div>
        </div>
      </div>
    </>
  );

};

export default AccessPage;
